import React, { useState } from "react"
import { Box, Flex } from "@theme-ui/components"
import { LanguageSwitcherContext } from "../context/languageSwitcherContext"
import { InboundLink } from "./link"

const LanguageSwitcherMobile = () => {
  const [show, setShow] = useState(false)
  const languagesCountry = {
    it: "Italiano",
    en: "English",
    "en-us": "English (United States)",
    "en-ca": "English (Canada)",
    fr: "Français",
    de: "Deutsch",
    es: "Español",
    pt: "Português",
    pl: "Polski",
    ru: "Русский",
  }
  return (
    <LanguageSwitcherContext.Consumer>
      {({ activeLocale, paths }) => {
        const activeLink = paths.find(x => x.locale === activeLocale)
        return (
          <Box sx={{ position: "relative" }}>
            <Flex
              as={"ul"}
              sx={{
                flexDirection: "column",
                padding: 2,
                backgroundColor: "primary",
                listStyle: "none",
              }}
            >
              {paths//.sort((a, b) => a.locale.localeCompare(b.locale))
                .map((link, index) => (
                  <Box as="li" key={index}>
                    <InboundLink
                      href={link.value}
                      sx={{
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                        paddingX: 3,
                        paddingY: [3, 2],
                        fontSize: 0,
                        display: "block",
                        textTransform: "uppercase",
                        textDecoration: activeLocale === link.locale ?"underline" : "unset",
                        color: "light",
                      }}
                    >
                      {languagesCountry[link.locale] || link.locale}
                    </InboundLink>
                  </Box>
                ))}
            </Flex>
          </Box>
        )
      }}
    </LanguageSwitcherContext.Consumer>
  )
}

export default LanguageSwitcherMobile
